import { render, staticRenderFns } from "./ModattaDashboardSnapTabs.vue?vue&type=template&id=a8a8aa38&scoped=true"
import script from "./ModattaDashboardSnapTabs.vue?vue&type=script&lang=js"
export * from "./ModattaDashboardSnapTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a8aa38",
  null
  
)

export default component.exports